import { Center, Flex, Image, Text } from "@chakra-ui/react";
import LoadingOverlay from "components/LoadingOverlay";
import env from "env";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLoginMutation } from "redux/services/auth";
import iconSuccess from "assets/images/success-circle.svg";
import iconError from "assets/images/error-triangle.svg";

const OAuth2: React.FC<{
  forceSuccess?: boolean;
  forceFailed?: boolean;
}> = ({ forceSuccess, forceFailed }) => {
  const { push } = useHistory();
  const [login, { isSuccess, isLoading, isError, error }] = useLoginMutation();

  useEffect(() => {
    if (isSuccess) {
      push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const codeVerifier = window.localStorage.getItem("code_verifier");

    if (code && codeVerifier) {
      const body = {
        client_id: env.app.authCodeAppId,
        code: code,
        code_verifier: codeVerifier,
        redirect_uri: `${env.app.rootUrl}`,
        grant_type: "authorization_code",
      };

      login(body);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Center
      w="100%"
      h="100%"
      overflow="auto"
      mt="0 !important"
      p={["24px 15px", null, 0]}
    >
      {isLoading ? (
        <LoadingOverlay h="100%" />
      ) : (
        <Flex
          flexDir="column"
          h="100%"
          w={["100%", "364px"]}
          justify={["flex-start", null, "center"]}
        >
          <Image
            mt="52px"
            mb="30px"
            src={forceSuccess || isSuccess ? iconSuccess : iconError}
            alt="Success"
            loading="lazy"
          />
          {(forceSuccess || isSuccess) && (
            <>
              <Text textAlign="center" textStyle="h2">
                Authorize successfully!
              </Text>
              <Text mt="5px" textAlign="center" textStyle="h5">
                You will navigate in system screen
              </Text>
            </>
          )}
          {(forceFailed || isError) && (
            <>
              <Text textAlign="center" color="red" textStyle="h2">
                {(error as any)?.data?.error_description}
              </Text>
            </>
          )}
        </Flex>
      )}
    </Center>
  );
};

export default OAuth2;
